import { createSvgIcon } from '@mui/material';
import React from 'react';

export const BulkLineItemIcon = createSvgIcon(
    <>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_69_10104)">
                <path
                    d="M17.4863 13H12.9863V17.5H11.4863V13H6.98633V11.5H11.4863V7H12.9863V11.5H17.4863V13Z"
                    fill="currentColor"
                />
                <path
                    d="M10.4863 7H5.98633V11.5H4.48633V7H-0.0136719V5.5H4.48633V1H5.98633V5.5H10.4863V7Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_69_10104">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    </>,
    'BulkLineItemIcon'
);
